export default '7F2CE';
